import script from "./TableContextToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TableContextToolbar.vue?vue&type=script&setup=true&lang=js"

import "./TableContextToolbar.vue?vue&type=style&index=0&id=5483d854&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5483d854"]])

export default __exports__